import React from "react";
import { LazyLoadImages } from "@quintype/components";

import { StoryPage as StoryPageBase } from "../components/pages/story";
import { StoryPagePreview as StoryPagePreviewBase } from "../components/pages/story-preview";
import { StoryPageStatic as StoryPageStaticBase } from "../components/pages/story/static-page/story-static";
import { RasipalanLandingPage as RasipalanLandingPageBase } from "../components/pages/rasipalan-landing";
import { GurupeyarchiLandingPage as GurupeyarchiLandingPageBase } from "../components/pages/gurupeyarchi-landing";
import { GurupeyarchiStoryPage as GurupeyarchiStoryPageBase } from "../components/pages/gurupeyarchi-story";
import { DfpAd } from "../../isomorphic/components/atoms/dfp-ad";

function wrapLazyLoadImages(Template) {
  const ImageLazyLoadedComponent = props => {
    return (
      <LazyLoadImages margin={"150px"}>
        <DfpAd adtype="Automated" placement="all" />
        <Template {...props} />
      </LazyLoadImages>
    );
  };
  ImageLazyLoadedComponent.displayName = `WrapLazyLoadImages(${Template.name})`;
  return ImageLazyLoadedComponent;
}

export const StoryPage = StoryPageBase;
export const StoryPagePreview = wrapLazyLoadImages(StoryPagePreviewBase);
export const StoryPageStatic = wrapLazyLoadImages(StoryPageStaticBase);
export const RasipalanLandingPage = wrapLazyLoadImages(RasipalanLandingPageBase);
export const GurupeyarchiLandingPage = wrapLazyLoadImages(GurupeyarchiLandingPageBase);
export const GurupeyarchiStoryPage = wrapLazyLoadImages(GurupeyarchiStoryPageBase);
